import { unstable_capitalize as capitalize } from '@material-ui/utils';
export default capitalize;